module.exports = __webpack_public_path__ + "img/go_home.26555cf6.png";